import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import {
  createInsightsSettings,
  getInsightsSettings,
  getRevenueAction,
  getVehicleAmountAction,
} from "./actions/insightsActions";

// Define a type for the slice state
interface insightsState {
  loader: true | false;
  revenueInsights: [];
  vehicleAmount: any;
  settings: [];
}
const initialState: insightsState = {
  loader: false,
  revenueInsights: [],
  vehicleAmount: [],
  settings: [],
};

export const insightsSlice = createSlice({
  name: "insights",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // handle Asynchronous Calls
    // Get getRevenueAction methods
    builder.addCase(getRevenueAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getRevenueAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getRevenueAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.revenueInsights = payload;
    });
    // ./getRevenueAction methods

    // Get getVehicleAmountAction methods
    builder.addCase(getVehicleAmountAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getVehicleAmountAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getVehicleAmountAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.vehicleAmount = payload;
    });
    // ./getVehicleAmountAction methods

    // Get getInsightsSettings methods
    builder.addCase(getInsightsSettings.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getInsightsSettings.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getInsightsSettings.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.settings = payload;
    });
    // ./getInsightsSettings methods

    // Get createInsightsSettings methods
    builder.addCase(createInsightsSettings.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(createInsightsSettings.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(createInsightsSettings.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.settings = payload;
    });
    // ./createInsightsSettings methods
  },
});

export const loader = (state: RootState) => state.insights.loader;
export const selectRevenueInsights = (state: RootState) => state.insights.revenueInsights;
